module.exports = __webpack_public_path__ + "static/media/MobilityandSolidity.b994d31c.jpg";